module.exports = __webpack_public_path__ + "static/img/icn_chatbot.b29d5a9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_chatbot.gif
// module id = aBo2
// module chunks = 10